import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import s from './TermsConditionsModal.css';

class TermsConditionsModal extends React.Component {
  render() {
    return (
      <div
        id="myModal"
        className={cx(
          s.modal,
          this.props.showAgreementModal ? s.modalOpen : s.modalClose,
        )}
      >
        <div className={s.modalContent}>
          <div
            className={s.close}
            onClick={() => this.props.onToggleAgreementModal()}
            aria-hidden="true"
          >
            &times;
          </div>
          <div className={s.modalContentBody}>
            <div
              className={s.titleModal}
              dangerouslySetInnerHTML={{
                __html: this.props.termsConditions.title,
              }}
            />
            <div
              className={s.contentModal}
              dangerouslySetInnerHTML={{
                __html: this.props.termsConditions.description,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

TermsConditionsModal.propTypes = {
  termsConditions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  onToggleAgreementModal: PropTypes.func,
  showAgreementModal: PropTypes.bool,
};

TermsConditionsModal.defaultProps = {
  termsConditions: {
    title: '',
    description: '',
  },
  onToggleAgreementModal: () => {},
  showAgreementModal: false,
};

const mapState = state => ({
  user: state.user,
  booking: state.booking,
  termsConditions: state.common.termsConditions,
});

export default connect(mapState)(withStyles(s)(TermsConditionsModal));
